export default "__VITE_ASSET__DO$851$H__"